"use strict";exports.__esModule = true;exports.toKebabCase = void 0;var toKebabCase = exports.toKebabCase = function toKebabCase(value) {
  if (!value) {
    return '';
  }

  return value.
  split(/\.?(?=[A-Z])/).
  join('-').
  toLowerCase();
};